module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/check-circle-va.14de15ca.svg";